import React, {ReactElement} from "react"
import {AllowedBillPayTermsColumns, BillPayTermsColumns} from "./BillPayTerms.types"
import {BillpayTerms} from "../../resources/billpayTerms"
import {Resource} from "../../resources/common"
import {useNavigate} from "react-router-dom"
import {DataTableCell, DataTableRow} from "../../components/DataTable/DataTable"
import {OrgName} from "../../components/OrgName/OrgName"
import moment from "moment"
import IdLink from "../../components/IdLink/IdLink"

interface BillPayTermsRowProps {
	billpayTerms: BillpayTerms
	include?: Resource[]
	includedColumns: Array<AllowedBillPayTermsColumns>
}

export default function BillPayTermsRow({billpayTerms, include, includedColumns}: BillPayTermsRowProps) {
	const navigate = useNavigate()

	const contentColumns: Partial<Record<AllowedBillPayTermsColumns, ReactElement>> = {}

	if (includedColumns.includes(BillPayTermsColumns.id)) {
		contentColumns["Id"] = (
			<DataTableCell className="data-table-id-cell">
				<IdLink className="data-table-id" href={`/billpay-terms/${billpayTerms.id}`}>
					{billpayTerms.id}
				</IdLink>
			</DataTableCell>
		)
	}

	if (includedColumns.includes(BillPayTermsColumns.status)) {
		contentColumns["Status"] = (
			<DataTableCell>
				<div className={`billpay-terms-status ${billpayTerms.attributes.status}`}>{billpayTerms.attributes.status}</div>
			</DataTableCell>
		)
	}

	if (includedColumns.includes(BillPayTermsColumns.org)) {
		if (billpayTerms?.relationships?.org) {
			contentColumns["Org"] = <OrgName orgId={billpayTerms.relationships.org.data.id} included={include} />
		} else {
			contentColumns["Org"] = <DataTableCell> -- </DataTableCell>
		}
	}

	if (includedColumns.includes(BillPayTermsColumns.name)) {
		contentColumns["Name"] = <DataTableCell>{billpayTerms.attributes.name}</DataTableCell>
	}

	if (includedColumns.includes(BillPayTermsColumns.createdAt)) {
		contentColumns["Created At"] = (
			<DataTableCell>{moment(billpayTerms.attributes.createdAt).format("L")}</DataTableCell>
		)
	}

	const content: Array<ReactElement | null> = []

	includedColumns.forEach((col, i) => {
		if (col in contentColumns && contentColumns[col]) {
			const column = {...contentColumns[col]} as ReactElement
			column.key = i.toString()
			content.push(column)
		}
	})

	return (
		<DataTableRow
			onClick={(e) => {
				e.preventDefault()
				e.stopPropagation()
				navigate(`/billpay-terms/${billpayTerms.id}`)
			}}
		>
			{content}
		</DataTableRow>
	)
}
